module.exports = __webpack_public_path__ + "media/payments/upgrade-year-17014ccb.png";